const actions = {
  brandApiName: 'BRAND_API',
  requestBrand: 'brand/request',
}

export default actions
